import {
  useMutation,
  UseMutationResult,
  useQuery,
  UseQueryResult,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { API } from "../../utils/API/API";
import { EventType } from ".";

export type AddProgress = {
  event: {
    content: number;
    isViewComponent: boolean;
    eventType: EventType;
    meta?: Record<string, any>;
  };
};

export type ContentGenerateBody = {
  contentId: string;
  sectionId: string;
  // TODO: change this options prfefernce
  preferenceType: "simplify" | "advanced" | "concise";
};

export type ICodeExecution = {
  language: string;
  code: string;
};

export const useAddProgress = (init: {
  course: string;
  module: string;
  lesson?: string;
  practice?: string;
}): UseMutationResult<
  IApiResponse<{ message: string }>,
  AxiosError<{ message: string }>,
  AddProgress,
  unknown
> => {
  return useMutation({
    mutationFn: (body: AddProgress) => API.addProgress({ ...body, ...init }),
  });
};

export const useRegenarateContent = (): UseMutationResult<
  IApiResponse<string>,
  AxiosError<{ message: string }>,
  ContentGenerateBody,
  unknown
> => {
  return useMutation({
    mutationFn: (body: ContentGenerateBody) => API.regenerateContent(body),
  });
};

export const useConsumeModule = (
  id: string
): UseQueryResult<IModule<any> & { progress: IProgress }, AxiosError> => {
  return useQuery({
    queryKey: ["module", "consume"],
    queryFn: () => API.consumeModule(id),
    refetchOnWindowFocus: false,
  });
};

type OuputResponse = {
  run: {
    code: number;
    output: string;
    signal: string;
    stderr: string;
    stdout: string;
  };
};

export const useCodeExecution = (): UseMutationResult<
  OuputResponse,
  AxiosError<{ message: string }>,
  any,
  unknown
> => {
  return useMutation({
    mutationFn: (body: ICodeExecution) => API.codeExecute(body),
  });
};
